export default __webpack_public_path__ + "static/media/team28.2198b1b5.JPG";